import { render } from "./AppCheckbox.vue?vue&type=template&id=27f33596"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__